export const LayoutFeatureFlags = {
  SSLCommerzBanner: true,
};
